import { jwtDecode } from "jwt-decode";
import { setUserData } from "../redux/slices/login/login";
import { TokenResponseType } from "../types/TokenResponse";
import { useAppDispatch } from "./hooks";
import { AUTH_LOCALSTORAGE } from "../utils/constants";

const useDecodeToken = () => {
    const dispatch = useAppDispatch();
    return () => {
        const token = localStorage.getItem(AUTH_LOCALSTORAGE);
        if (!token) return;

        try {
            const decodedToken: TokenResponseType = jwtDecode(token);
            dispatch(setUserData(decodedToken));
        } catch (error) {
            console.error("Invalid token", error);
        }
    };
};

export default useDecodeToken;